export default {
  "common-try-slogin": "Authing ,すべてのものが使える身分。",
  "common-button-立即试用": "直ちに試用する",

  nav: {
    "nav-home": "ホーム",
    "nav-product": "製品とサービス",
    "nav-solution": "ソリューション",
    "nav-solution-medical": "医療",
    "nav-solution-government": "政府",
    "nav-solution-education": "教育",
    "nav-solution-finance": "金融",
    "nav-solution-game": "ゲーム",
    "nav-solution-software": "ソフトウェア",
    "nav-solution-publisher": "出版",
    "nav-document": "文書",
    "nav-price": "価格",
    "nav-abuoutus": "オン Authing",
    "nav-console": "ダッシュボード",
    "nav-login": "ログイン登録",
    "nav-logout": "ログアウト",
  },
  footer: {
    "footer-product": "产品介绍",
    "footer-product-advance": "製品のメリット",
    "footer-platform": "オープンプ ラットフォーム",
    "footer-platform-api": "Open API",
    "footer-platform-resource": "開発者のリソース",
    "footer-platform-problem": "FAQ",
    "footer-platform-example": "統合ケース",
    "footer-support": "技術支援",
    "footer-support-community": "開発者コミュニティ",
    "footer-support-Github": "Github",
    "footer-support-blog": "技術ブログ",
    "footer-company": "公司信息",
    "footer-company-joinus": "参加する",
    "footer-company-phone": "400-6197-031",
    "footer-company-email": "sales@authing.cn",
    "footer-company-address": "北京市海淀区成府路 45 号中关村智造大街 G 座",
    "footer-language": "语言",
    "footer-adress": "京ICP备19051205号-7",
    "footer-copyright": "© 北京蒸気記憶技術有限会社",
  },
  common: {
    "product-sso": "シングルサインオン",
    "product-mfa": "多要素認証",
    "product-comp": "ユニバーサル ログイン フォーム コンポーネント",
    "product-verify": "携帯電話番号で検証",
    "product-security": "セキュリティとコンプライアンス",
  },
  button: {
    "try-now": "直ちに試用する",
    "see-more": "もっと見る",
    "learn-more": "詳細を表示",
    "develop-consult": "開発コンサルティング",
    "develop-community": "コミュニティを開発する",
  },
};
